exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task-status-badge[data-v-072ba5dd]{color:#fff;width:80px;font-family:Open Sans,sans-serif;font-size:10px;font-weight:700;letter-spacing:0;line-height:24px;padding:2px 12px;border-radius:5px;text-align:center}.task-status-badge.success[data-v-072ba5dd]{background-color:#2ecc71}.task-status-badge.warning[data-v-072ba5dd]{background-color:#fb8c00}.task-status-badge.secondary[data-v-072ba5dd]{background-color:#c2c2c2}", ""]);

// exports
